import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { RegionService } from '../../services/region.service';
import { SessionService, ZeissPanel } from '../../services/session.service';
import { NetworkStatusService } from '../../services/network-status.service';
import { SharedConstants } from '../../services/shared/shared-constants';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'slide5-page',
  templateUrl: 'slide5.html',
})
export class Slide5Page {
  onlineStatus: boolean;
  constructor(
    private router: Router,
    public regionService: RegionService,
    public sessionService: SessionService,
    public networkService: NetworkStatusService,
    private trackingService: TrackingService
  ) {
    this.networkService.online$.subscribe((res) => {
      this.onlineStatus = res;
    });
  }

  prev(): void {
    this.onlineStatus ? this.router.navigate(['devices']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
    this.trackingService.resetTrackingValues();
  }

  next(): void {
    this.onlineStatus ? this.router.navigate(['visual-behaviour']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
  }

  selectPanel(panel: ZeissPanel): void {
    panel.selected = !panel.selected;
  }
}



// WEBPACK FOOTER //
// ./src/pages/slide5/slide5.ts